import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setCredentials } from "../features/auth/authSlice";

const useAuthInitializer = () => {
  const dispatch = useDispatch();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      dispatch(setCredentials({ accessToken: token }));
    }
    setInitialized(true);
  }, [dispatch]);

  return initialized;
};

export default useAuthInitializer;
